import { createEnv } from '@t3-oss/env-core';

import { CLIENT_ENV_PREFIX, clientEnvSchema } from './env.schema';

/**
 * Validated environment for application code; the only module in the app allowed to read
 * `import.meta.env`. Everything else imports `env` from here, so a typo becomes a type error
 * instead of a silent `undefined` at runtime.
 */
export const env = createEnv({
  clientPrefix: CLIENT_ENV_PREFIX,
  client: clientEnvSchema,
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});

/** Vite's build-mode flag, re-exported so this stays the only module reading `import.meta.env`. */
export const isDev = import.meta.env.DEV;
